import { ErrorToast } from "../components/toastify";
import { AxiosGetMethod } from "../helpers/customAxios";
import HandleLogout from "./handleLogout";

const HandleGetEventList = async (
  from,
  to,
  search_value,
  type,
  payment_pending_only = false,
  pagination = null,
) => {
  const endpoint = `org/all-events?`;
  let queryParam = [];
  if (from) queryParam.push(`start_date=${from}`);
  if (to) queryParam.push(`end_date=${to}`);
  if (type) queryParam.push(`result_type=${type}`);
  if (search_value && search_value.length > 0)
    queryParam.push(`search_value=${encodeURIComponent(search_value)}`);
  if (payment_pending_only) queryParam.push(`payment_pending_only=1`);
  if (pagination?.page) queryParam.push(`page=${pagination.page}`);
  if (pagination?.perPage) queryParam.push(`per_page=${pagination.perPage}`);
  const eventList = await AxiosGetMethod(
    `${endpoint}${queryParam.join("&")}`
    // `org/events?start_date=2024-11-11&end_date=2025-05-31&search_value=po`
  );
  if (eventList?.status === 200) {
    const data = eventList.data.data;
    if (pagination && data && !Array.isArray(data)) {
      return {
        items: Array.isArray(data.items) ? data.items : [],
        pagination: data.pagination || null,
        summary: data.summary || null,
      };
    }
    if (Array.isArray(data)) {
      return data;
    }
    return [];
  } else {
    if (eventList?.status === 401) HandleLogout();
    ErrorToast("Something went wrong on fetch event list");
    return [];
  }
};

export default HandleGetEventList;
